import React from "react";
import { Card, Col, Divider, Row, Typography } from "antd";
import { BOM } from "../../../../services/definedMethod";

const { Text } = Typography;

const Preview = (props) => {
  const { formData, loanProductDetails } = props;

  const data = {
    details: [
      {
        name: "Product Name",
        value: formData?.details?.name ? formData.details.name : "-",
      },
      {
        name: "Short Name",
        value: formData?.details?.shortName ? formData.details.shortName : "-",
      },
      {
        name: "Fund Name",
        value: formData?.details?.fundId
          ? loanProductDetails?.fundOptions?.find((item) => item.id === formData?.details?.fundId)
              .name
          : "-",
      },
      {
        name: "Description",
        value: formData?.details?.description ? formData.details.description : "-",
      },
      {
        name: "Start Date",
        value: formData?.details?.startDate ? formData.details.startDate : "-",
      },
      {
        name: "Close Date",
        value: formData?.details?.closeDate ? formData.details.closeDate : "-",
      },
      {
        name: "Include In Customer Loan Counter",
        value: formData?.details?.includeInBorrowerCycle === true ? "true" : "false",
      },
    ],

    currency: [
      {
        name: "Currency",
        value: formData?.currency?.currencyCode ? formData.currency.currencyCode : "-",
      },
      {
        name: "Decimal Places",
        value: formData?.currency?.digitsAfterDecimal ? formData.currency.digitsAfterDecimal : "-",
      },
      {
        name: "Currency In Multiples Of",
        value: formData?.currency?.inMultiplesOf ? formData.currency.inMultiplesOf : "-",
      },
      {
        name: "Installments in multiples of",
        value: formData?.currency?.installmentAmountInMultiplesOf
          ? formData.currency.installmentAmountInMultiplesOf
          : "-",
      },
    ],

    terms: [
      {
        name: "Terms Vary Based On Loan Cycle",
        value: formData?.terms?.useBorrowerCycle === true ? "true" : "false",
      },
      {
        name: "Principal",
        value: formData?.terms?.principal ? BOM.FormatAmount(formData.terms.principal) : "-",
      },
      {
        name: "Number Of Repayments",
        value: formData?.terms?.numberOfRepayments
          ? BOM.FormatAmount(formData.terms.numberOfRepayments)
          : "-",
      },
      {
        name: "Is linked to floating interest rates",
        value: formData?.terms?.isLinkedToFloatingInterestRates === true ? "true" : "false",
      },
      {
        name: "Nominal Interest Rate",
        value: formData?.terms?.interestRatePerPeriod ? formData.terms.interestRatePerPeriod : "-",
      },

      {
        name: "Interest Rate Frequency",
        value: formData?.terms?.interestRateFrequencyType
          ? loanProductDetails?.interestRateFrequencyTypeOptions?.find(
              (item) => item.id === formData?.terms?.interestRateFrequencyType,
            ).value
          : "-",
      },

      {
        name: "Repayment Frequency",
        value: formData?.terms?.repaymentFrequencyType
          ? loanProductDetails?.repaymentFrequencyTypeOptions?.find(
              (item) => item.id === formData?.terms?.repaymentFrequencyType,
            ).value
          : "-",
      },

      {
        name: "Minimum Days Between Disbursal And First Repayment Date",
        value: formData?.terms?.minimumDaysBetweenDisbursalAndFirstRepayment
          ? formData.terms.minimumDaysBetweenDisbursalAndFirstRepayment
          : "-",
      },
    ],
    settings: [
      {
        name: "Amortization",
        value: formData?.settings?.amortizationType
          ? loanProductDetails?.amortizationTypeOptions?.find(
              (item) => item.id === formData?.settings?.amortizationType,
            ).value
          : "-",
      },
      {
        name: "Interest Method",
        value: String(formData?.settings?.interestType)
          ? loanProductDetails?.interestTypeOptions?.find(
              (item) => String(item.id) === String(formData?.settings?.interestType),
            ).value
          : "-",
      },
      {
        name: "Is Equal Amortization",
        value: formData?.settings?.isEqualAmortization === true ? "true" : "false",
      },
      {
        name: "Interest Calculation Period",
        value: String(formData?.settings?.interestCalculationPeriodType)
          ? loanProductDetails?.interestCalculationPeriodTypeOptions?.find(
              (item) =>
                String(item.id) === String(formData?.settings?.interestCalculationPeriodType),
            ).value
          : "-",
      },
      {
        name: "Repayment Strategy",
        value: String(formData?.settings?.transactionProcessingStrategyId)
          ? loanProductDetails?.transactionProcessingStrategyOptions?.find(
              (item) => item.id === formData?.settings?.transactionProcessingStrategyId,
            ).name
          : "-",
      },
      {
        name: "Moratorium",
        value: formData?.settings?.graceOnPrincipalPayment
          ? formData.settings.graceOnPrincipalPayment
          : "-",
      },
      {
        name: "Interest Free Period",
        value: formData?.settings?.graceOnInterestCharged
          ? formData.settings.graceOnInterestCharged
          : "-",
      },
      {
        name: "Arrears Tolerance",
        value: formData?.settings?.inArrearsTolerance ? formData.settings.inArrearsTolerance : "-",
      },
      {
        name: "Days In Year",
        value: formData?.settings?.daysInYearType
          ? loanProductDetails?.daysInYearTypeOptions?.find(
              (item) => item.id === formData?.settings?.daysInYearType,
            ).value
          : "-",
      },
      {
        name: "Days In Month",
        value: formData?.settings?.daysInMonthType
          ? loanProductDetails?.daysInMonthTypeOptions?.find(
              (item) => item.id === formData?.settings?.daysInMonthType,
            ).value
          : "-",
      },
      {
        name: "Allow Fixing Of The Installment Amount",
        value: formData?.settings?.canDefineInstallmentAmount === true ? "true" : "false",
      },
      {
        name: "Number of days a loan may be overdue before moving into arrears",
        value: formData?.settings?.graceOnArrearsAgeing
          ? formData.settings.graceOnArrearsAgeing
          : "-",
      },
      {
        name: "Maximum number of days a loan may be overdue before becoming a NPA (non performing asset)",
        value: formData?.settings?.overdueDaysForNPA ? formData.settings.overdueDaysForNPA : "-",
      },
      {
        name: "Account moves out of NPA only after all arrears have been cleared?",
        value: formData?.settings?.closeDate ? formData.settings.closeDate : "-",
      },
      {
        name: "Principal Threshold (%) for Last Installment",
        value: formData?.settings?.principalThresholdForLastInstallment
          ? formData.settings.principalThresholdForLastInstallment
          : "-",
      },
      {
        name: "Is Variable Installments Allowed?",
        value: formData?.settings?.allowVariableInstallments === true ? "true" : "false",
      },
      {
        name: "Is allowed to be used for providing Topup Loans?",
        value: formData?.settings?.canUseForTopup === true ? "true" : "false",
      },
      {
        name: "Recalculate Interest",
        value: formData?.settings?.isInterestRecalculationEnabled === true ? "true" : "false",
      },
      {
        name: "Place Guarantee Funds On-Hold?",
        value: formData?.settings?.holdGuaranteeFunds === true ? "true" : "false",
      },
      {
        name: "Enable Multiple Disbursals",
        value: formData?.settings?.multiDisburseLoan === true ? "true" : "false",
      },
    ],
    accounting: [
      {
        name: "Fund Source",
        value: formData?.accounting?.fundSourceAccountId
          ? loanProductDetails?.accountingMappingOptions?.assetAccountOptions?.find(
              (item) => item.id === formData?.accounting?.fundSourceAccountId,
            ).name
          : "-",
      },
      {
        name: "Loan Portfolio",
        value: formData?.accounting?.loanPortfolioAccountId
          ? loanProductDetails?.accountingMappingOptions?.assetAccountOptions?.find(
              (item) => item.id === formData?.accounting?.loanPortfolioAccountId,
            ).name
          : "-",
      },
      {
        name: "Transfer In Suspense",
        value: formData?.accounting?.transfersInSuspenseAccountId
          ? loanProductDetails?.accountingMappingOptions?.assetAccountOptions?.find(
              (item) => item.id === formData?.accounting?.transfersInSuspenseAccountId,
            ).name
          : "-",
      },

      {
        name: "Interest Receivable",
        value: formData?.accounting?.receivableInterestAccountId
          ? loanProductDetails?.accountingMappingOptions?.assetAccountOptions?.find(
              (item) => item.id === formData?.accounting?.receivableInterestAccountId,
            ).name
          : "-",
      },
      {
        name: "Fees Receivable",
        value: formData?.accounting?.receivableFeeAccountId
          ? loanProductDetails?.accountingMappingOptions?.assetAccountOptions?.find(
              (item) => item.id === formData?.accounting?.receivableFeeAccountId,
            ).name
          : "-",
      },
      {
        name: "Penalties Receivable",
        value: formData?.accounting?.receivablePenaltyAccountId
          ? loanProductDetails?.accountingMappingOptions?.assetAccountOptions?.find(
              (item) => item.id === formData?.accounting?.receivablePenaltyAccountId,
            ).name
          : "-",
      },
      {
        name: "Income From Interest",
        value: formData?.accounting?.interestOnLoanAccountId
          ? loanProductDetails?.accountingMappingOptions?.incomeAccountOptions?.find(
              (item) => item.id === formData?.accounting?.interestOnLoanAccountId,
            ).name
          : "-",
      },
      {
        name: "Income From Fees",
        value: formData?.accounting?.incomeFromFeeAccountId
          ? loanProductDetails?.accountingMappingOptions?.incomeAccountOptions?.find(
              (item) => item.id === formData?.accounting?.incomeFromFeeAccountId,
            ).name
          : "-",
      },
      {
        name: "Income From Penalties",
        value: formData?.accounting?.incomeFromPenaltyAccountId
          ? loanProductDetails?.accountingMappingOptions?.incomeAccountOptions?.find(
              (item) => item.id === formData?.accounting?.incomeFromPenaltyAccountId,
            ).name
          : "-",
      },
      {
        name: "Income From Recovery Payments",
        value: formData?.accounting?.incomeFromRecoveryAccountId
          ? loanProductDetails?.accountingMappingOptions?.incomeAccountOptions?.find(
              (item) => item.id === formData?.accounting?.incomeFromRecoveryAccountId,
            ).name
          : "-",
      },
      {
        name: "Losses Written Off",
        value: formData?.accounting?.writeOffAccountId
          ? loanProductDetails?.accountingMappingOptions?.expenseAccountOptions?.find(
              (item) => item.id === formData?.accounting?.writeOffAccountId,
            ).name
          : "-",
      },

      {
        name: "Overpayment Liability",
        value: formData?.accounting?.overpaymentLiabilityAccountId
          ? loanProductDetails?.accountingMappingOptions?.liabilityAccountOptions?.find(
              (item) => item.id === formData?.accounting?.overpaymentLiabilityAccountId,
            ).name
          : "-",
      },
    ],
  };
  return (
    <Card
      style={{
        marginBottom: "2%",
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
      }}
    >
      {/* DETAILS FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Details"}
        </Divider>
        {data.details.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* CURRENCY FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Currency"}
        </Divider>
        {data.currency.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* TERMS FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Terms"}
        </Divider>
        {data.terms.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* SETTINGS FORM */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Settings"}
        </Divider>
        {data.settings.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* ACCOUNTING FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Accounting"}
        </Divider>
        {data.accounting.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default Preview;
